export default [
  772, // Permite alterar os parametros
  397, // Tipo operação saída consumidos
  398, // Tipo operação entrada fabricados
  399, // Tipo operação entrada defeito
  400, // Tipo operação entrada perdidos
  392, // Centro armazenagem produção
  393, // Centro armazenagem fabricados
  394, // Centro armazenagem defeito
  395, // Centro armazenagem perdidos
  901, // TG
  426, // Ocorrência de entrada fabricados
  427, // Ocorrência de entrada defeito
  428, // Ocorrência de entrada perdidos
  404, // Confirmar quantidades
  402, // Leitura por
  403, // Area de Processo
  2016, // Divisão dos colaboradores padrão
  3096, // Exigir informar colaborador ao ler ordem de produção
  21, // Unidade de negócio padrão
  2549, // É possível substituir demandas
  1545, // Impressão de etiqueta disponível
];
